import { createAsyncThunk } from "@reduxjs/toolkit";
import facturaApi from "./api";
import {
  setLoading,
  setError,
  setFacturas,
  setClients,
  setCurrentFactura,
  addFactura,
  updateFactura
} from "./slice";

// Get all facturas
export const getFacturas = createAsyncThunk(
  "facturas/getFacturas",
  async (params, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await facturaApi.getFacturas(params);
      dispatch(setFacturas(response));
      return response;
    } catch (error) {
      dispatch(setError(error.message || "Failed to fetch facturas"));
      throw error;
    }
  }
);

// Get single factura
export const getFactura = createAsyncThunk(
  "facturas/getFactura",
  async (id, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await facturaApi.getFactura(id);
      dispatch(setCurrentFactura(response));
      return response;
    } catch (error) {
      dispatch(setError(error.message || "Failed to fetch factura"));
      throw error;
    }
  }
);

// Create factura
export const createFactura = createAsyncThunk("facturas/createFactura", async (data) => {
  const response = await facturaApi.createFactura(data);
  return response;
});

// Update factura
export const updateFacturaThunk = createAsyncThunk(
  "facturas/updateFactura",
  async ({ id, data }) => {
    const response = await facturaApi.updateFactura(id, data);
    return response;
  }
);

// Delete factura
export const deleteFacturaThunk = createAsyncThunk(
  "facturas/deleteFactura",
  async (id) => {
    await facturaApi.deleteFactura(id);
    return id;
  }
);

// Get clients for dropdown
export const getClients = createAsyncThunk(
  "facturas/getClients",
  async (_, { dispatch }) => {
    try {
      const response = await facturaApi.getClients();
      dispatch(setClients(response));
      return response;
    } catch (error) {
      dispatch(setError(error.message || "Failed to fetch clients"));
      throw error;
    }
  }
);
